import { defineStore } from 'pinia'
import { axiosService } from '@/utils/axiosService'
import { storageService } from '@/utils/storageService'

import dayjs from 'dayjs'
import 'dayjs/locale/id'

import _ from 'lodash'
import router from '@/router'

dayjs.locale('id')
//Store utama (pengganti Vuex createStore)
export const useAuthStore = defineStore('auth', {
  state: () => ({
    meta: { title: import.meta.env.VITE_TITLE },
    BoUserToken: null,
    RefreshToken: null,
    BoUser: {},
    loadingGlobal: false,
    loadingLogout: false,
    Roles: [],
    RSession: {},
  }),

  getters: {
    authenticated: (state) => !!(state.BoUserToken && state.BoUser?.username),
    hasPanelRole: (state) => state.BoUser?.hasPanelRole == 'Y',
  },

  actions: {
    updateUser(value = null) {
      value = value || { level: {} }
      this.BoUser = value
      if (value) storageService.putStorage('BoUser', value)
      else storageService.removeStorage('BoUser')
    },

    updateUserToken(value = null) {
      this.BoUserToken = value
      if (value) storageService.putStorage('BoUserToken', value)
      else storageService.removeStorage('BoUserToken')
    },

    updateRefreshToken(value = null) {
      this.RefreshToken = value
      if (value) storageService.putStorage('RefreshToken', value)
      else storageService.removeStorage('RefreshToken')
    },

    logoutUserToken() {
      if (window.refreshUA) clearInterval(window.refreshUA)
      const token = this.BoUserToken

      this.loadingLogout = true
      globalThis.Swal.fire({
        title: 'Signing out...',
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          globalThis.Swal.showLoading()
        },
      })

      this.BoUserToken = null
      this.RefreshToken = null
      this.BoUser = {}
      this.RSession = {}
      this.Roles = []

      storageService.removeStorage('BoUser')
      storageService.removeStorage('BoUserToken')
      storageService.removeStorage('RefreshToken')

      axiosService.apiRest('/auth/logout?token=' + token,{
        method: 'DELETE',
      })
        .then(() => {
          this.loadingLogout = false
        })
        .catch(() => {
          this.loadingLogout = false
        })
        .finally(() => {
          this.loadingLogout = false
          setTimeout(() => {
            router.replace({ name: 'LoginView' })
            globalThis.Swal.close()
          }, 700)
        })
    },

    setDefaultRole(v) {
      v.loading = true

      axiosService.apiRest('/auth/default-role', {
        method: 'POST',
        data: {
          id: v.id,
        },
      })
        .then((res) => {
          v.loading = false
          this.Roles.forEach((value, index) => (this.Roles[index].is_default = 'N'))
          v.is_default = 'Y'
        })
        .catch(() => {
          v.loading = false
        })
    },

    turnOnLoading() {
      this.loadingGlobal = true
      document.body.style.overflow = 'hidden'
    },

    turnOffLoading() {
      this.loadingGlobal = false
      document.body.style.overflow = 'unset'
    },

    async watchAuth() {
      const params = new URLSearchParams(location.search)
      const uToken = params.get('uToken')
      // LOCAL MODE
      if (uToken && import.meta.env.VITE_MODE === 'local') {
        console.log('MASUK')
        const response = await fetch(
          import.meta.env.VITE_API_URL + '/local-only?uToken=' + uToken,
          {
            method: 'GET',
            credentials: 'include',
            // headers: { 'X-API-KEY': 'Basic ' + import.meta.env.VITE_API_KEY },
          },
        )
        storageService.putStorage('BoUserToken', await response.text())

        window.location.href = import.meta.env.VITE_BASE_URL
        return
      }

      // NORMAL MODE
      const userToken = storageService.getStorage('BoUserToken')
      this.updateUserToken(userToken)

      if (userToken) {
        try {
          let resp = await axiosService.apiRest('/auth/info')
          resp = resp.data
          if (resp.status === 'success') {
            this.updateUser(resp.data)
            if (
              ['', '/', 'LoginView', 'JpanelLogin', undefined].indexOf(window.location.pathname) >
              -1
            ) {
              router.push({ name: 'AdmHome' })
            }
          }
        } catch (error) {
          console.error(error)
          this.logoutUserToken()
        }
      }
    },
  },

  // Data tetap tersimpan di localStorage antar refresh/tab
  persist: {
    pick: ['BoUserToken', 'BoUser', 'RefreshToken', 'Roles', 'RSession'],
    storage: localStorage,
  },
})
